module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('site-contractors-table', {
    attrs: {
      "site-id": _vm.siteId
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e884b296"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/finance/contractors/SiteContractors.vue
// module id = 1732
// module chunks = 0